import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getStoredSubscription } from '../utils/subscriptionStorage';
import { hasValidSubscriptionAccess } from '../utils/subscriptionHelpers';
import { isPatient } from '../utils/helpers';
import {
  CHECKOUT,
  PROFILE,
  SUBSCRIPTIONS,
  VIDEO_CALL_TEST,
} from '../utils/urls';

export const SUBSCRIPTION_ALLOWED_PATHS = [
  PROFILE,
  SUBSCRIPTIONS,
  VIDEO_CALL_TEST,
  CHECKOUT,
];

export const isSubscriptionAllowedPath = (pathname = '') =>
  SUBSCRIPTION_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

function useSubscriptionAccess() {
  const reduxSubscription = useSelector(
    (state) => state.user && state.user.subscription
  );
  const subscriptionLoaded = useSelector(
    (state) => state.user && state.user.subscriptionLoaded
  );
  const sessionEmail = useSelector(
    (state) => state.session && state.session.email
  );
  const userType = useSelector(
    (state) => state.session && state.session.userType
  );
  const location = useLocation();
  const subscriptionRequired = isPatient(userType);
  const subscription = reduxSubscription || getStoredSubscription();
  const hasValidSubscription = useMemo(
    () => hasValidSubscriptionAccess(subscription),
    [subscription]
  );
  const hasAccess = !subscriptionRequired || hasValidSubscription;
  const isChecking =
    subscriptionRequired && Boolean(sessionEmail) && !subscriptionLoaded;
  const isAllowedRoute = isSubscriptionAllowedPath(location.pathname);

  return {
    hasAccess,
    subscription,
    isChecking,
    isAllowedRoute,
    subscriptionRequired,
    canVisitCurrentRoute:
      !subscriptionRequired || hasAccess || isAllowedRoute,
  };
}

export default useSubscriptionAccess;
